<template>
<div v-if="dataLoaded">
             <b-tabs >
            <b-tab title="Seleção">
               <b-row>
            <b-col md="6">
              <b-form-group label="Enviar para:">
                  <b-form-radio-group
                    id="radio-slots"
                    v-model="value.type"
                    :options="states.campaigns.recipientTypes"
                    name="radio-options-slots"
                    @input="changedRecipientType"
                  ></b-form-radio-group>

              </b-form-group>
            </b-col>
        </b-row>
        <div>
          <conditions :recipienttype="value.type"  v-model="value.conditions" :regions="regions" :activities="activities" :membertypes="memberTypes" v-on:updated-conditions="changedConditions">
          </conditions>

        </div>
            </b-tab>
            <b-tab :title="'Pré-visualizar ' + recipientsCount">
              <b-btn variant="primary" class="mt-1" @click="previewRecipients" >Pré-visualizar</b-btn>
              <p>Total de destinatários: {{ recipientsCount }}</p>
              <PreviewRecipients v-if="value.type == 1" :recipients="recipientsPreview"></PreviewRecipients>
              <PreviewRecipientsPersons v-if="value.type == 2" :recipients="recipientsPreview"></PreviewRecipientsPersons>
            </b-tab>
          </b-tabs>
</div>
</template>

<script>
import Lists from '@/components/Lists.js'
import Conditions from './conditions.vue'
import PreviewRecipients from './preview_recipients.vue'
import PreviewRecipientsPersons from './preview_recipients_persons.vue'

export default {
  components: {
    Conditions, PreviewRecipients, PreviewRecipientsPersons
  },
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      states: Lists,
      dataLoaded: false,
      memberTypes: [],
      regions: [],
      activities: [],
      recipientsCount: 0,
      recipientsPreview: [],
    }
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
    selectedValues() {
      this.value.values = this.selectedValues
      this.$emit("input", this.value);
    },
  },
  methods: {
    changedConditions() {
      console.log('changed conditions')
      this.previewRecipients()
    },
    changedRecipientType() {
      this.value.conditions = [{
            operator:Lists.campaigns.recipientConditionsOperator[0],
            conditions: [{type: null, values:[]}]
          }]
    },
    previewRecipients() {
      let data = {recipients:this.value}
      this.axios.post('email/campaigns/preview_recipients', data).then(response => {
        console.log('total', response.data);
        this.recipientsCount = response.data.count
        this.recipientsPreview = response.data.data
      })
    },
  },
  created() {
    let calls = [this.axios.get('familymembertypes/lst'), this.axios.get('regions/lst'), this.axios.get('activities/lst')]
    let callbacks = []
    let that = this
    callbacks.push(function(response) {
      that.memberTypes = response.data
    })
    callbacks.push(function(response) {
      that.regions = response.data
    })
    callbacks.push(function(response) {
      that.activities = response.data
    })



     that.axios.all(calls)
     .then(that.axios.spread((...args) => {
        for (let i = 0; i < args.length; i++) {
            callbacks[i](args[i].data)
        }
        that.dataLoaded = true;
    }))
  }
}
</script>
